var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "div",
        { staticClass: "head-container" },
        [
          _vm.crud.props.searchToggle
            ? _c(
                "div",
                [
                  _c("el-input", {
                    staticClass: "filter-item",
                    staticStyle: { width: "200px" },
                    attrs: {
                      clearable: "",
                      size: "small",
                      placeholder: "输入部门名称搜索",
                    },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.crud.toQuery($event)
                      },
                    },
                    model: {
                      value: _vm.query.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.query, "name", $$v)
                      },
                      expression: "query.name",
                    },
                  }),
                  _vm._v(" "),
                  _c("date-range-picker", {
                    staticClass: "date-item",
                    model: {
                      value: _vm.query.createTime,
                      callback: function ($$v) {
                        _vm.$set(_vm.query, "createTime", $$v)
                      },
                      expression: "query.createTime",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      staticClass: "filter-item",
                      staticStyle: { width: "90px" },
                      attrs: {
                        clearable: "",
                        size: "small",
                        placeholder: "状态",
                      },
                      on: { change: _vm.crud.toQuery },
                      model: {
                        value: _vm.query.enabled,
                        callback: function ($$v) {
                          _vm.$set(_vm.query, "enabled", $$v)
                        },
                        expression: "query.enabled",
                      },
                    },
                    _vm._l(_vm.enabledTypeOptions, function (item) {
                      return _c("el-option", {
                        key: item.key,
                        attrs: { label: item.display_name, value: item.key },
                      })
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c("rrOperation"),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("crudOperation", { attrs: { permission: _vm.permission } }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            "append-to-body": "",
            "close-on-click-modal": false,
            "before-close": _vm.crud.cancelCU,
            visible: _vm.crud.status.cu > 0,
            title: _vm.crud.status.title,
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.crud.status, "cu > 0", $event)
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                inline: "",
                model: _vm.form,
                rules: _vm.rules,
                size: "small",
                "label-width": "80px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "部门名称", prop: "name" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "370px" },
                    model: {
                      value: _vm.form.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "name", $$v)
                      },
                      expression: "form.name",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "合同前缀", prop: "contractPrefix" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "370px" },
                    model: {
                      value: _vm.form.contractPrefix,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "contractPrefix", $$v)
                      },
                      expression: "form.contractPrefix",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "经销商前缀", prop: "distributorPrefix" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "370px" },
                    model: {
                      value: _vm.form.distributorPrefix,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "distributorPrefix", $$v)
                      },
                      expression: "form.distributorPrefix",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "部门排序", prop: "deptSort" } },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "370px" },
                    attrs: { min: 0, max: 999, "controls-position": "right" },
                    model: {
                      value: _vm.form.deptSort,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "deptSort", _vm._n($$v))
                      },
                      expression: "form.deptSort",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "顶级部门" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      staticStyle: { width: "140px" },
                      model: {
                        value: _vm.form.isTop,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "isTop", $$v)
                        },
                        expression: "form.isTop",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "1" } }, [_vm._v("是")]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: "0" } }, [_vm._v("否")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "状态", prop: "enabled" } },
                _vm._l(_vm.dict.dept_status, function (item) {
                  return _c(
                    "el-radio",
                    {
                      key: item.id,
                      attrs: { label: item.value },
                      model: {
                        value: _vm.form.enabled,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "enabled", $$v)
                        },
                        expression: "form.enabled",
                      },
                    },
                    [_vm._v(_vm._s(item.label))]
                  )
                }),
                1
              ),
              _vm._v(" "),
              _vm.form.isTop === "0"
                ? _c(
                    "el-form-item",
                    {
                      staticStyle: { "margin-bottom": "0" },
                      attrs: { label: "上级部门", prop: "pid" },
                    },
                    [
                      _c("treeselect", {
                        staticStyle: { width: "370px" },
                        attrs: {
                          "load-options": _vm.loadDepts,
                          options: _vm.depts,
                          placeholder: "选择上级类目",
                        },
                        model: {
                          value: _vm.form.pid,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "pid", $$v)
                          },
                          expression: "form.pid",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { type: "text" }, on: { click: _vm.crud.cancelCU } },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { loading: _vm.crud.status.cu === 2, type: "primary" },
                  on: { click: _vm.crud.submitCU },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.crud.loading,
              expression: "crud.loading",
            },
          ],
          ref: "table",
          attrs: {
            lazy: "",
            load: _vm.getDeptDatas,
            "tree-props": { children: "children", hasChildren: "hasChildren" },
            data: _vm.crud.data,
            "row-key": "id",
          },
          on: {
            select: _vm.crud.selectChange,
            "select-all": _vm.crud.selectAllChange,
            "selection-change": _vm.crud.selectionChangeHandler,
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              selectable: _vm.checkboxT,
              type: "selection",
              width: "55",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", { attrs: { label: "名称", prop: "name" } }),
          _vm._v(" "),
          _c("el-table-column", { attrs: { label: "排序", prop: "deptSort" } }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "状态", align: "center", prop: "enabled" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-switch", {
                      attrs: {
                        disabled: scope.row.id === 1,
                        "active-color": "#409EFF",
                        "inactive-color": "#F56C6C",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.changeEnabled(scope.row, scope.row.enabled)
                        },
                      },
                      model: {
                        value: scope.row.enabled,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "enabled", $$v)
                        },
                        expression: "scope.row.enabled",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "createTime", label: "创建日期" },
          }),
          _vm._v(" "),
          _vm.checkPer(["admin", "dept:edit", "dept:del"])
            ? _c("el-table-column", {
                attrs: {
                  label: "操作",
                  width: "130px",
                  align: "center",
                  fixed: "right",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("udOperation", {
                            attrs: {
                              data: scope.row,
                              permission: _vm.permission,
                              "disabled-dle": scope.row.id === 1,
                              msg: "确定删除吗,如果存在下级节点则一并删除，此操作不能撤销！",
                            },
                          }),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  3153448024
                ),
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }